import { spawn } from 'node:child_process';
import { existsSync } from 'node:fs';
import * as path from 'node:path';

/**
 * Candidate locations of the built agent-ui bundle: env override, the bundle shipped
 * inside the published package (`dist/repl.mjs`, next to the CLI entry; `.mjs` because
 * the CLI package is CommonJS), then the monorepo sibling layouts.
 */
export function replBinCandidates(dir: string, envBin = process.env.SPACECODE_REPL_BIN): string[] {
  return [
    ...(envBin ? [envBin] : []),
    path.resolve(dir, 'repl.mjs'),
    path.resolve(dir, '../../agent-ui/dist/index.js'),
    path.resolve(dir, '../../../agent-ui/dist/index.js'),
  ];
}

/** First candidate that exists, or null. */
export function resolveReplBin(dir: string, exists: (p: string) => boolean = existsSync): string | null {
  return replBinCandidates(dir).find((p) => exists(p)) ?? null;
}

/** Run the local agent REPL (packages/agent-ui) attached to this terminal; resolves with its exit code. */
export async function startLocalRepl(opts: { yolo?: boolean; resume?: boolean; args?: string[] } = {}): Promise<number> {
  const bin = resolveReplBin(__dirname);
  if (!bin) {
    throw new Error(
      'Local REPL not built. Run `pnpm --filter @spacecode/agent-ui build` (or set SPACECODE_REPL_BIN), ' +
        'or use `spacecode --cloud` for a cloud session.',
    );
  }
  const args = [bin, ...(opts.args ?? []), ...(opts.yolo ? ['--yolo'] : []), ...(opts.resume ? ['--continue'] : [])];
  return new Promise<number>((resolve, reject) => {
    const child = spawn(process.execPath, args, { stdio: 'inherit' });
    child.on('error', reject);
    child.on('exit', (code, signal) => {
      if (signal) return reject(new Error(`REPL terminated by signal ${signal}`));
      resolve(code ?? 0);
    });
  });
}
